import React, { useState } from "react";
import AuthGuard from "../components/AuthGuard/AuthGuard";
import EddForm from "../components/Form/EddForm";
import CloseAction from "../components/ui/CloseAction/CloseAction";
import EddStatusView from "../components/View/EddStatusView";
import { useAuth } from "../hooks/useAuth";
import { Issuer } from "../types/auth.types";
import { extractRedirectUrl } from "../utils/extractRedirectUrl";

const Edd: React.FC = () => {
  const { issuer } = useAuth();
  const isHmac = issuer === Issuer.HMAC;
  const [showForm, setShowForm] = useState(!isHmac);

  const setView = (show: boolean) => setShowForm(show);

  const handleSubmissionSuccess = () => {
    const redirectUrl = extractRedirectUrl();
    if (redirectUrl) {
      // Redirect after 10 seconds if redirect_url is provided
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 10000);
    } else if (isHmac) {
      // Navigate to status screen if redirect_url not provided and HMAC mode
      setView(false);
    }
  };

  return (
    <AuthGuard>
      <div className="relative min-h-screen">
        {/* Close Action - Only for HMAC */}
        {isHmac && <CloseAction />}

        {showForm ? (
          <EddForm
            onSubmissionSuccess={handleSubmissionSuccess}
            isHmac={isHmac}
          />
        ) : (
          <EddStatusView setShowForm={() => setView(true)} />
        )}
      </div>
    </AuthGuard>
  );
};

export default Edd;
